import { Routes } from "@angular/router";
import { WorkflowEndcustomerOneAvailabilityOrderCancelComponent } from "./workflow-endcustomer-one-availability-order-cancel.component";

export const WorkflowEndcustomerOneAvailabilityOrderCancelRouting: Routes = [
    {
        path: 'availability/:aid/order-cancel', component: WorkflowEndcustomerOneAvailabilityOrderCancelComponent
    },
]
